import React from 'react';

import Home from 'pages/Home';
import TradeHistory from 'pages/TradeHistory';
import AssetTransition from 'pages/AssetTransition';
import NotificationList from 'pages/NotificationList';
import NotificationDetail from 'pages/NotificationDetail';
import NotificationSetting from 'pages/NotificationSetting';
import TimelyDisclosure from 'pages/TimelyDisclosure';
import AsstsChangeNotification from 'pages/AsstsChangeNotification';
// TODO: Ph1.5以降
// import AnnualResult from 'pages/AnuualResult';
// TODO: Ph1.5以降
// import ChangePlan from 'pages/ChangePlan';
import SecurityAccounts from 'pages/SecurityAccounts';
import TradeDetail from 'pages/TradeDetail';
import News from 'pages/News';
import SecurityAccountsLink from 'pages/SecurityAccountsLink';
import AccountDetail from 'pages/AccountDetail';
import Grouping from 'pages/Grouping';
import OptionalAssetRegistration from 'pages/OptionalAssetRegistration';
import OptionalAssetRenewal from 'pages/OptionalAssetRenewal';
import NewReport from 'pages/NewReport';
import AccountLinkedInfo from 'pages/AccountLinkageInfo';
import PersonaChart from 'pages/PersonaChart';
import DividendPrediction from 'pages/DividendPrediction';
import DividendDeposit from 'pages/DividendDeposit';
import DividendDetailPrediction from 'pages/DividendDetailPrediction';
import DividendDetailDeposit from 'pages/DividendDetailDeposit';
import Importantnotification from 'pages/Importantnotification';
import InvestorIdExplanation from 'pages/InvestorIdExplanation';
import InvestorIdRegistrationError from 'pages/InvestorIdRegistrationError';
import TargetIndex from 'components/features/target-achievement-support/pages/TargetIndex';
import TargetCreate from 'components/features/target-achievement-support/pages/TargetCreate';
import TargetSelect from 'components/features/target-achievement-support/pages/TargetSelect';
import TargetRegister from 'components/features/target-achievement-support/pages/TargetRegister';
import TargetSetAmount from 'components/features/target-achievement-support/pages/TargetSetAmount';
import TargetSetTitle from 'components/features/target-achievement-support/pages/TargetSetTitle';
import TargetDetail from 'components/features/target-achievement-support/pages/TargetDetail';
import TargetUpdateStep1 from 'components/features/target-achievement-support/pages/TargetUpdateStep1';
import TargetUpdateStep2 from 'components/features/target-achievement-support/pages/TargetUpdateStep2';
import TargetUpdateConfirm from 'components/features/target-achievement-support/pages/TargetUpdateConfirm';
import TargetUpdateInfo from 'components/features/target-achievement-support/pages/TargetUpdateInfo';
import WhatIsNecessaryYield from 'components/features/target-achievement-support/pages/WhatIsNecessaryYield';
import HowToIncreaseAccumulationAmount from 'components/features/target-achievement-support/pages/HowToIncreaseAccumulationAmount';
import PortfolioAnalysisIndex from 'components/features/target-achievement-support/pages/PortfolioAnalysisIndex';
import PortfolioAnalysisAssetInformation from 'components/features/target-achievement-support/pages/PortfolioAnalysisAssetInformation';
import PortfolioAnalysisInvestmentProduct from 'components/features/target-achievement-support/pages/PortfolioAnalysisInvestmentProduct';
import PortfolioAnalysisChangeManagementSelect from 'components/features/target-achievement-support/pages/PortfolioAnalysisChangeManagementSelect';
import PortfolioAnalysisChangeManagementConfirm from 'components/features/target-achievement-support/pages/PortfolioAnalysisChangeManagementConfirm';
import PortfolioAnalysisChangeManagementComplete from 'components/features/target-achievement-support/pages/PortfolioAnalysisChangeManagementComplete';

import * as env from 'config/environment';
import * as H from 'components/features/home/Home';

export type Item = {
  path: string;
  pathApp?: string;
  title: string;
  subTitle?: string;
  menuTitle?: string;
  iconName?: string;
  subMenuList?: Array<Item>;
  component?: React.ComponentType;
  menuType?: number;
  children?: Array<Item>;
  exact?: boolean;
  subActivePaths?: string[]; // この中に入っているパスでも、MenuItemのリンクがアクティブになる
  doNotShowOnSideMenuApp?: boolean;
  useSkipAgreeModal?: () => SkipAgreeModal;
  id?: string;
  isNewIcon?: boolean;
  isIosPremium?: boolean;
};

export type SkipAgreeModal = 'loading' | 'show' | 'later';

const dailyReport: Item = {
  path: '/dailyreport',
  title: '日次レポート',
  component: NewReport,
  exact: false,
};

const otherNewReport: Item[] = [
  {
    path: '/weeklyreport',
    title: '週次レポート',
    component: NewReport,
    exact: false,
  },
  {
    path: '/monthlyreport',
    title: '月次レポート',
    component: NewReport,
    exact: false,
  },
  // TODO: 表示速度改善対応リリースのため一時的に年次レポートへの同線をコメントアウト
  // {
  //   path: '/yearlyreport',
  //   title: '年次レポート',
  //   component: NewReport,
  //   exact: false,
  // },
];

const newReport: Item[] = [dailyReport, ...otherNewReport];

const target: Item = {
  path: '/target',
  exact: true,
  title: '',
  subTitle: '資産目標サポート',
  menuTitle: '目標・分析',
  iconName: 'flag',
  component: TargetIndex,
  subActivePaths: ['/target/:id'],
  isIosPremium: true,
};

export const targetPathsObject = {
  targetCreate: {
    path: '/target/create/:type',
    title: '目標の設定',
    component: TargetCreate,
    exact: true,
  },
  targetSelect: {
    path: '/target/select',
    title: '',
    component: TargetSelect,
    exact: true,
  },
  targetRegister: {
    path: '/target/:id/register',
    title: '',
    component: TargetRegister,
    exact: true,
  },
  targetIndexSetAmount: {
    path: '/target/:id/set-amount',
    title: '目標金額・時期の見直し',
    component: TargetSetAmount,
    exact: true,
  },
  targetIndexSetTitle: {
    path: '/target/:id/set-title',
    title: '目標タイトルの編集',
    component: TargetSetTitle,
    exact: true,
  },
  targetDetail: {
    path: '/target/:id',
    title: '',
    component: TargetDetail,
    exact: true,
  },
  targetUpdateStep1: {
    path: '/target/:id/update/step1/:mode',
    title: '',
    component: TargetUpdateStep1,
    exact: true,
  },
  targetUpdateStep2: {
    path: '/target/:id/update/step2/:mode',
    title: '',
    component: TargetUpdateStep2,
    exact: true,
  },
  targetUpdateInfo: {
    path: '/target/:id/update/info/:mode',
    title: '',
    component: TargetUpdateInfo,
    exact: true,
  },
  targetUpdateConfirm: {
    path: '/target/:id/update/confirm/:mode',
    title: '',
    component: TargetUpdateConfirm,
    exact: true,
  },
  targetUpdateStep1Test: {
    path: '/target/:id/update/step1/:mode/test',
    title: '',
    component: TargetUpdateStep1,
    exact: true,
  },
  targetUpdateConfirmTest: {
    path: '/target/:id/update/confirm/:mode/test',
    title: '',
    component: TargetUpdateConfirm,
    exact: true,
  },
  whatIsNecessaryYield: {
    path: '/target/:id/whatIsNecessaryYield',
    title: '必要な年利回りとは',
    component: WhatIsNecessaryYield,
    exact: true,
  },
  howToIncreaseAccumulationAmount: {
    path: '/target/:id/howToIncreaseAccumulationAmount',
    title: '家計の見直し',
    component: HowToIncreaseAccumulationAmount,
    exact: true,
  },
  PortfolioAnalysis: {
    path: '/target/:id/portfolio-analysis',
    title: 'ポートフォリオ分析',
    component: PortfolioAnalysisIndex,
    exact: true,
  },
  PortfolioAnalysisAssetInformation: {
    path: '/target/:id/portfolio-analysis/asset/:type',
    title: '',
    component: PortfolioAnalysisAssetInformation,
  },
  PortfolioAnalysisInvestmentProduct: {
    path: '/target/:id/portfolio-analysis/asset/:type/detail',
    title: '',
    component: PortfolioAnalysisInvestmentProduct,
  },
  PortfolioAnalysisChangeManagement: {
    path: '/target/:id/portfolio-analysis/change-assets',
    title: '運用タイプ変更画面',
    component: PortfolioAnalysisChangeManagementSelect,
  },
  PortfolioAnalysisChangeManagementConfirm: {
    path: '/target/:id/portfolio-analysis/change-assets/confirm/:type',
    title: '運用タイプ変更画面',
    component: PortfolioAnalysisChangeManagementConfirm,
  },
  PortfolioAnalysisChangeManagementComplete: {
    path: '/target/:id/portfolio-analysis/change-assets/complete/:type',
    title: '運用タイプ変更画面',
    component: PortfolioAnalysisChangeManagementComplete,
  },
} as const;

const targetPaths: Item[] = Object.values(targetPathsObject);

const global = new Array<Item>(
  {
    path: '/home',
    title: 'ホーム',
    iconName: 'home',
    component: Home,
    useSkipAgreeModal: H.useSkipAgreeModal,
  },
  target,
  {
    path: '/tradehistory',
    title: '取引履歴',
    iconName: 'trade',
    component: TradeHistory,
  },
  {
    path: '/dividendprediction',
    title: '配当金管理',
    menuTitle: '配当金',
    iconName: 'dividend',
    component: DividendPrediction,
    subActivePaths: ['/dividenddeposit'],
    isNewIcon: true,
    isIosPremium: true,
  },
  // TODO: 表示速度改善対応リリースのため一時的に年次レポートへの同線をコメントアウト
  // {
  //   path: '/dailyreport',
  //   title: 'レポート',
  //   iconName: 'file-text',
  //   component: NewReport,
  //   subActivePaths: ['/weeklyreport', '/monthlyreport', '/yearlyreport'],
  // }
  {
    path: '/dailyreport',
    title: 'レポート',
    iconName: 'file-text',
    component: NewReport,
    subActivePaths: ['/weeklyreport', '/monthlyreport'],
  }
  // {
  //   path: '/annualresult',
  //   title: '年間成績',
  //   iconName: 'trophy',
  //   component: AnnualResult,
  // }
);

const sideMenuTypes = {
  Nomal: 1,
  Logout: 2,
  User: 3,
  UserAsset: 4,
  FinancialProduct: 5,
  Beginner: 6,
};

const side_logout = new Array<Item>(
  {
    path: `${env.accountSettingURL}?service=${
      env.serviceName
    }&callback_url=${encodeURI(`${env.appURL}/auth`)}`,
    title: '会員情報',
    id: 'side_memberInformation',
  },
  {
    path: `${env.logoutURL}?service=${env.serviceName}&callback_url=${env.appURL}`,
    title: 'ログアウト',
    id: 'side_logout',
  }
);

export const snslinkages = '/snslinkages';

export const snspreview = '/snspreview';

const side_asset = new Array<Item>(
  {
    path: '/home',
    title: 'ホーム',
    component: Home,
  },
  {
    path: '/???',
    title: 'お知らせ',
  },
  {
    path: '/notificationSetting',
    title: '通知・お知らせ設定',
    component: NotificationSetting,
  },
  {
    path: '/securityaccounts',
    title: '連携口座一覧',
    component: SecurityAccounts,
  },
  target,
  {
    path: '/tradehistory',
    title: '取引履歴',
    iconName: 'trade',
    component: TradeHistory,
  },
  {
    path: '/dividendprediction',
    title: '配当金管理',
    component: DividendPrediction,
    isNewIcon: true,
    isIosPremium: true,
  },
  {
    path: '/personachart',
    title: 'ペルソナチャート',
    component: PersonaChart,
    isNewIcon: true,
  },
  {
    path: '/dailyreport',
    title: 'レポート',
    iconName: 'file-text',
    component: NewReport,
    subActivePaths: ['/weeklyreport', '/monthlyreport'],
  },
  {
    path: '/grouping',
    title: '資産のグルーピング',
    component: Grouping,
  },
  {
    path: '/assettransition',
    title: '資産推移',
    iconName: '',
    component: AssetTransition,
  },
  {
    path: `${env.accountSettingURL}?service=${
      env.serviceName
    }&callback_url=${encodeURI(`${env.appURL}/auth`)}`,
    title: '会員情報',
    id: 'side_memberInformation',
  }
  // ポイント関連を一時的に非非常
  // {
  //   path: '/point',
  //   title: 'ポイント',
  //   component: Point,
  // },
);

const side_beginner = new Array<Item>(
  {
    path: env.beginnerURL,
    title: '株 初心者入門',
    id: 'side_stock_fromBeginner',
  },
  {
    path: env.investmentTrustFundBeginnerURL,
    title: '投資信託 初心者',
    id: 'side_investmentTrust_fromBeginner',
  },
  {
    path: env.foreignExchangeBeginnerURL,
    title: 'FX 初心者入門',
    id: 'side_FX_fromBeginner',
  },
  {
    path: env.cryptocurrencyBeginnerURL,
    title: '暗号資産 入門',
    id: 'side_virtualCurrency_fromBeginner',
  },
  {
    path: env.reitBeginnerURL,
    title: '不動産投資 入門',
    id: 'side_realEstateInvestment_fromBeginner',
  },
  {
    path: env.futuresBeginnerURL,
    title: '先物取引 入門',
    id: 'side_futures_fromBeginner',
  },
  {
    path: env.insuranceBeginnerURL,
    title: '保険コラム',
    id: 'side_insuranceColumn_fromBeginner',
  },
  {
    path: env.securityCompanyCompareURL,
    title: '証券会社比較',
    id: 'side_ComparisonOfSecuritiesCompanies_fromBeginner',
  },
  {
    path: env.foreignExchangeCompareURL,
    title: 'FX会社比較',
    id: 'side_FXCompanyComparison_fromBeginner',
  },
  {
    path: env.cryptocurrencyCompareURL,
    title: '暗号資産取引所比較',
    id: 'side_virtualCurrencyExchangeComparison_fromBeginner',
  }
);

const side = new Array<Item>(
  {
    path: '/???',
    title: 'ログアウト',
    menuType: sideMenuTypes.Logout,
    subMenuList: [...side_logout],
  },
  {
    path: '/???',
    title: '資産情報の確認',
    menuType: sideMenuTypes.UserAsset,
    subMenuList: [...side_asset],
  },
  {
    path: env.myPageURL,
    pathApp: env.myPageSpURL,
    title: '株式マイページ',
    menuType: sideMenuTypes.User,
    doNotShowOnSideMenuApp: true,
    id: 'side_stockMypage',
    isIosPremium: false,
  },
  {
    path: env.investmentTrustFundFavoritesURL,
    title: '投資信託 お気に入り',
    menuType: sideMenuTypes.User,
    doNotShowOnSideMenuApp: true,
    id: 'side_investmentTrustFavorites',
    isIosPremium: false,
  },
  {
    path: env.stockURL,
    title: '株式',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_stock_fromMedia',
  },
  {
    path: env.usStockURL,
    title: '米国株',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_usStock_fromMedia',
  },
  {
    path: env.foreignExchangeURL,
    title: 'FX/為替',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_FX_fromMedia',
  },
  {
    path: env.cryptocurrencyURL,
    title: '仮想通貨（暗号資産）',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_virtualCurrency_fromMedia',
  },
  {
    path: env.futuresURL,
    title: '先物',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_futures_fromMedia',
  },
  {
    path: env.investmentTrustFundURL,
    title: '投信',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_investmentTrust_fromMedia',
  },
  {
    path: env.insuranceURL,
    title: '保険',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_insurance_fromMedia',
  },
  {
    path: env.magURL,
    title: 'みんかぶマガジン',
    menuType: sideMenuTypes.FinancialProduct,
    id: 'side_magazine_fromMedia',
  },
  {
    path: '/???',
    title: '初心者',
    menuType: sideMenuTypes.Beginner,
    subMenuList: [...side_beginner],
  },
  {
    path: env.companyURL,
    title: '運営会社',
    menuType: sideMenuTypes.Nomal,
    id: 'side_operatingCompany',
  },
  {
    path: env.termsOfServiceURL,
    title: '利用規約',
    menuType: sideMenuTypes.Nomal,
    id: 'side_terms',
  },
  {
    path: env.privacyPolicyURL,
    title: 'プライバシーポリシー',
    menuType: sideMenuTypes.Nomal,
    id: 'side_privacyPolicy',
  },
  {
    path: env.trusteURL,
    title: 'プライバシー・ステートメント',
    menuType: sideMenuTypes.Nomal,
    id: 'side_privacyStatement',
  },
  {
    path: env.economyURL,
    title: '特定商取引表示',
    menuType: sideMenuTypes.Nomal,
    id: 'side_specifiedCommercialTransactionDisplay',
  },
  {
    path: env.lawURL,
    title: 'ご利用上の注意（関連法規）',
    menuType: sideMenuTypes.Nomal,
    id: 'side_note',
  },
  {
    path: env.advertisingURL,
    title: '広告掲載・取扱商品',
    menuType: sideMenuTypes.Nomal,
    id: 'side_advertising',
  },
  {
    path: env.helpURL,
    title: 'ヘルプ・お問い合わせ',
    menuType: sideMenuTypes.Nomal,
    id: 'side_help',
  }
);

const other = new Array<Item>(
  {
    path: '/notificationList/:menuNo/:startPage/:selectPage',
    title: 'お知らせ',
    iconName: '',
    component: NotificationList,
  },
  // memo: お知らせから遷移用
  {
    path: '/notificationDetail/:menuNo/:notificationID',
    title: 'お知らせ詳細',
    iconName: '',
    component: NotificationDetail,
  },
  // memo: 配当金から遷移用
  {
    path: '/notificationDetail/:menuNo/:notificationID/:symbol/:func',
    title: 'お知らせ詳細',
    iconName: '',
    component: NotificationDetail,
  },
  {
    path: '/notificationSetting',
    title: 'おしらせ設定',
    iconName: '',
    component: NotificationSetting,
  },
  {
    path: '/timelyDisclosure',
    title: '保有銘柄の適時開示',
    iconName: '',
    component: TimelyDisclosure,
  },
  {
    path: '/asstsChangeNotification',
    title: '資産変動のお知らせ',
    iconName: '',
    component: AsstsChangeNotification,
  },
  {
    path: '/assettransition',
    title: '資産推移',
    iconName: '',
    component: AssetTransition,
  },
  {
    path: '/tradedetail/:symbol',
    title: '取引詳細',
    iconName: '',
    component: TradeDetail,
  },
  {
    path: '/news/:symbol/:id',
    title: 'ニュース',
    iconName: '',
    component: News,
  },
  {
    path: '/securityaccountslink',
    title: '連携する口座の選択',
    iconName: '',
    component: SecurityAccountsLink,
  },
  {
    path: '/optionalassetregistration',
    title: '手入力口座登録',
    component: OptionalAssetRegistration,
  },
  {
    path: '/optionalassetrenewal/:id',
    title: '手入力口座更新',
    component: OptionalAssetRenewal,
  },
  // exactがあるためidが必須になってしまっているため冗長的に作成
  {
    path: '/optionalassetrenewal',
    title: '手入力口座更新',
    component: OptionalAssetRenewal,
  },
  {
    path: '/accountdetail/:account',
    title: '口座詳細',
    iconName: '',
    component: AccountDetail,
  },
  {
    path: '/accountlinkageinfo',
    title: '口座連携案内',
    component: AccountLinkedInfo,
    useSkipAgreeModal: () => 'later',
  },
  {
    path: '/dividenddeposit',
    title: '配当金管理',
    component: DividendDeposit,
  },
  {
    path: '/dividendprediction/detail/:date',
    title: '配当金管理',
    component: DividendDetailPrediction,
  },
  {
    path: '/dividenddeposit/detail/:date/:from/:to',
    title: '配当金管理',
    component: DividendDetailDeposit,
  },
  {
    path: '/importantnotification/:id',
    title: '',
    component: Importantnotification,
    useSkipAgreeModal: () => 'later',
  },
  {
    path: '/investoridexplanation',
    title: '',
    component: InvestorIdExplanation,
  },
  {
    path: '/investoridregistrationerror/:type',
    title: '',
    component: InvestorIdRegistrationError,
    useSkipAgreeModal: () => 'later',
  },
  ...targetPaths
);

export {
  global,
  side_logout,
  side_asset,
  side,
  other,
  sideMenuTypes,
  newReport,
};
